import { type FetchResult } from "@apollo/client"

export function handleMutationErrors<TResult>(result: FetchResult<TResult> | null) {
  if (!result?.errors?.length) {
    return false
  }

  for (const error of result.errors) {
    console.error(error)
  }

  return true
}
